import { axios, BaseApiUrl } from '../axios_config';

// 移动端复核
export const AddCheckforArkAsync = params =>{
    return axios.post(`${BaseApiUrl}/ReadyforTask/AddCheckforArkAsync`,{ ...params }).then(res => res.data);
}

// 查询备货复核列表
export const GetCheckforArkAsyncQuery = params =>{
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetCheckforArkAsyncQuery`, { params }).then(res => res.data);
}

// 查询备货复核计划明细
export const GetRecheckDetail = params =>{
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetCheckforArkDetailAsyncQuery`, { params }).then(res => res.data);
}

// 查询备货复核打包明细
export const GetRecheckDetailForBale = params =>{
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetCheckforArkDetailByshippingPlanDetailIDAsync`, { params }).then(res => res.data);
}

// 移动端查询未复核数据汇总
export const getRecheckCount = params =>{
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetRecheckCountByTransportType`, { params }).then(res => res.data);
}
